import { computed, ref } from '@vue/composition-api'

export function useDateRangePicker(from, to, options = {}) {

  const {
    mode = 'range',
    enableTime = true,
    enableSeconds = true,
    time_24hr = true,
    dateFormat = 'Y-m-d H:i:S',
    maxDate = 'today',
  } = options;

  const rangeDate = ref(null);
  const lastSelectedDates = ref([]);

  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  };

  const setDefaultTimes = (selectedDates, instance) => {

    if (selectedDates.length === 0) return;

    const newDates = [...selectedDates];
    let shouldUpdate = false;

    // Check if start date changed (date part only)
    if (newDates[0] && !isSameDate(newDates[0], lastSelectedDates.value[0])) {
      newDates[0].setHours(0, 0, 0, 0);
      shouldUpdate = true;
    }

    // Check if end date changed (date part only)
    if (newDates.length === 2 && newDates[1] &&
      !isSameDate(newDates[1], lastSelectedDates.value[1])) {
      newDates[1].setHours(23, 59, 59, 999);
      shouldUpdate = true;
    }

    if (shouldUpdate) {
      // Store the current dates
      lastSelectedDates.value = newDates.map(d => new Date(d));
      // Update picker
      instance.setDate(newDates, true);
    } else {
      // User is adjusting time, just update our tracking
      lastSelectedDates.value = selectedDates.map(d => new Date(d));
    }

    // updating from to
    if (lastSelectedDates.value.length > 1) {
       from.value = instance.formatDate(lastSelectedDates.value[0], dateFormat);
       to.value = instance.formatDate(lastSelectedDates.value[1], dateFormat);
    }

  };

  const pickerConfig = computed(() => ({
    mode,
    defaultDate: [
      new Date().setHours(0, 0, 0),
      new Date().setHours(23, 59, 59, 59),
    ],
    enableTime,
    enableSeconds,
    time_24hr,
    dateFormat,
    // maxDate,
    onChange: (selectedDates, dateStr, instance) => {
      setDefaultTimes(selectedDates, instance);
    },
  }));

  const resetPicker = () => {
    rangeDate.value = null;
    lastSelectedDates.value = [];
  };

  return {
    rangeDate,
    pickerConfig,
    resetPicker,
    lastSelectedDates
  };
}